import {PIXI} from '@colonist/pixi'
import {TextView} from './TextView'
import {GameFont} from '../GameFont'
import {GeneralButtonView} from './GeneralButtonView'
import {TranslationObject} from '@colonist/i18n'
import {GameColor} from '../GameColor'
import {Sprites} from '../ui_game/UIGameImageDictionary'
import {UIGameSpriteHandler} from '../UIGameSpriteHandler'

export class TextButtonView extends GeneralButtonView {
    protected textView: TextView
    protected subtextView: TextView | undefined

    constructor(x: number, y: number, w: number, h: number, container: PIXI.Container, fontSize: GameFont.Size = GameFont.Size.XL) {
        super(x, y, w, h, container)
        this.viewContainer.drawRoundedBg(UIGameSpriteHandler.getTextureFromSpritesheet(Sprites.bg_button_green_cta))
        this.textView = new TextView({key: 'strings:colonistCommon.utils.emptyString'}, 0, 0, this.width, this.height, this.viewContainer, fontSize, GameColor.getColor(GameColor.Color.White))
        this.textView.makeBold()
    }

    getTextView() {
        return this.textView
    }

    hide() {
        if(this.parent == undefined) return
        this.parent.removeChild(this)
    }

    updateText(text: TranslationObject, subtext?: TranslationObject) {
        this.textView.setText(text)
        this.textView.centerX()
        this.textView.repositionY(true)

        if(subtext) this.setSubtext(subtext)
        else this.removeSubtext()
    }

    private setSubtext(text: TranslationObject) {
        if(this.subtextView === undefined) {
            this.subtextView = new TextView(text, 0, 0, this.width, this.height, this.viewContainer, GameFont.Size.Small, GameColor.getColor(GameColor.Color.White))
            this.subtextView.centerX()
        }

        this.subtextView.setText(text)

        const bothTextsHeight = this.textView.height + this.subtextView.height
        const remainingSpace = this.height - bothTextsHeight
        this.textView.y = remainingSpace / 2
        this.subtextView.y = this.textView.y + this.textView.height
    }

    private removeSubtext() {
        this.subtextView?.destroy()
        this.subtextView = undefined
    }

    centerXInParent() {
        this.x = (this.parent.width - this.width) / 2
    }
}
